import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitAddCouponData = createAsyncThunk(
  "submitAddCouponSubmit/fetchAddCouponSubmit",
  async ({ payload }) => {
    try {
      const response = await api.post(
        `prometheus/station/add/coupon/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitAddCouponSlice = createSlice({
  name: "submitAddCoupon",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitAddCouponData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitAddCouponData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitAddCouponData.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default SubmitAddCouponSlice.reducer;
